export class ConditionAnd {
  type: string;
  and: Array<any>;

  constructor() {
    this.type = 'And';
    this.and = [];
  }
}
